export default "__VITE_ASSET__DFjhyp_1__"